// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-create-recipe {
  padding: 30px;
  background-color: #A5D6A7;
  border-radius: 20px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  max-width: 700px;
  margin: 50px auto;
  font-family: 'Rubik', sans-serif;
}

.admin-create-recipe h1 {
  text-align: center;
  color: #333;
  font-size: 32px;
  margin-bottom: 30px;
  font-weight: 700;
}

.admin-create-recipe form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.admin-create-recipe label {
  font-weight: 600;
  color: #333;
  display: block;
  margin-bottom: 8px;
  font-family: 'Rubik', sans-serif;
}

/* .recipe-card {
  background-color: #ffffff;
  border-radius: 15px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  padding: 20px;
  max-width: 500px;
  margin: auto;
  text-align: center;
  overflow: hidden;
} */

.recipe-image-container {
  position: relative;
  padding: 10px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
  text-align: center;
  max-height: 650px;
  overflow: hidden;
}

.recipe-image-thumbnail {
  max-width: 100%;
  max-height: 550px;
  width: auto;
  height: auto;
  object-fit: contain;
  border-radius: 10px;
  margin-bottom: 10px;
}

.selected-recipe-title {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  padding: 10px 15px;
  /* background-color: rgba(0, 0, 0, 0.6); */
  color: #fff;
  font-size: 20px;
  font-weight: 600;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.small-input {
  padding: 10px;
  height: 40px;
  border: 1px solid #ddd;
  border-radius: 10px;
  font-size: 16px;
  font-family: 'Rubik', sans-serif;
  width: 100%;
  box-sizing: border-box;
  background-color: #f9f9f9;
  transition: all 0.3s ease;
}

.file-input {
  width: 100%;
  padding: 10px;
  border: 1px dashed #ddd;
  border-radius: 10px;
  background-color: #f9f9f9;
}

.image-preview-container {
  margin-top: 15px;
  text-align: center;
}

.image-preview {
  max-width: 100%;
  max-height: 250px;
  border-radius: 10px;
  border: 1px solid #ddd;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  display: block;     
  margin: 0 auto;       
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;
  width: 100%;
  flex-direction: column;
  align-items: center;
}

.admin-create-recipe button {
  background: #004D40;
  color: #fff;
  border: none;
  padding: 15px;
  border-radius: 15px;
  font-size: 18px;
  font-family: 'Rubik', sans-serif;
  cursor: pointer;
  font-weight: 600;
  flex: 1 1;
  max-width: 250px;
  min-width: 200px;
  transition: all 0.3s ease;
  margin-bottom: 20px;
}

.admin-create-recipe button:hover {
  background: #2E7D32;
}

.cancel-btn9 {
  background: #dc3545 !important;
  max-width: 250px;
}

.cancel-btn9:hover {
  background: #c82333 !important;
}

@media (max-width: 768px) {
  .admin-create-recipe button,
  .cancel-btn {
    width: 80%;
  }
}

.success-message-container {
  position: fixed;
  top: 70px; 
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none; 
}

.success-message28 {
  color: #155724;
  background-color: #d4edda;
  border: 1px solid #c3e6cb;
  padding: 12px 20px;
  border-radius: 15px;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: inline-flex;
  align-items: center;
  max-width: 60% !important;
  text-align: center;
  animation: fadeInOut 3s ease-in-out forwards;
}

.error-message28 {
  color: #d32f2f;
  background-color: #fde7e9;
  border: 1px solid #d32f2f;
  padding: 12px;
  border-radius: 10px;
  display: flex !important;
  align-items: center !important;
  gap: 8px;
  margin: 10px auto !important; 
  font-weight: 600;
  width: 40%;
  justify-content: center !important;
  text-align: center;
}

.admin-create-recipe input:focus {
  border-color: #A5D6A7;
  outline: none;
  background-color: #ffffff;
  box-shadow: 0px 0px 8px rgba(76, 175, 80, 0.5);
}

@keyframes fadeInOut {
  0% { opacity: 0; transform: translateY(-20px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-20px); }
}

@media (max-width: 768px) {
  .admin-create-recipe {
    padding: 20px;
    max-width: 90%;
  }

  .admin-create-recipe h1 {
    font-size: 24px;
  }

  .button-group {
    flex-direction: column;
    gap: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/CreateRecipePage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;;;;;;;;GASG;;AAEH;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,0CAA0C;EAC1C,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,WAAW;EACX,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,qCAAqC;EACrC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,8BAA8B;EAC9B,QAAQ;EACR,4BAA4B;EAC5B,gBAAgB;EAChB,UAAU;EACV,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;EAC/C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,OAAO,UAAU,EAAE,4BAA4B,EAAE;AACnD;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;AACF","sourcesContent":[".admin-create-recipe {\n  padding: 30px;\n  background-color: #A5D6A7;\n  border-radius: 20px;\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);\n  max-width: 700px;\n  margin: 50px auto;\n  font-family: 'Rubik', sans-serif;\n}\n\n.admin-create-recipe h1 {\n  text-align: center;\n  color: #333;\n  font-size: 32px;\n  margin-bottom: 30px;\n  font-weight: 700;\n}\n\n.admin-create-recipe form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.admin-create-recipe label {\n  font-weight: 600;\n  color: #333;\n  display: block;\n  margin-bottom: 8px;\n  font-family: 'Rubik', sans-serif;\n}\n\n/* .recipe-card {\n  background-color: #ffffff;\n  border-radius: 15px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  padding: 20px;\n  max-width: 500px;\n  margin: auto;\n  text-align: center;\n  overflow: hidden;\n} */\n\n.recipe-image-container {\n  position: relative;\n  padding: 10px;\n  background: #fff;\n  border-radius: 12px;\n  box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n  text-align: center;\n  max-height: 650px;\n  overflow: hidden;\n}\n\n.recipe-image-thumbnail {\n  max-width: 100%;\n  max-height: 550px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n  border-radius: 10px;\n  margin-bottom: 10px;\n}\n\n.selected-recipe-title {\n  position: absolute;\n  bottom: 10px;\n  left: 0;\n  right: 0;\n  padding: 10px 15px;\n  /* background-color: rgba(0, 0, 0, 0.6); */\n  color: #fff;\n  font-size: 20px;\n  font-weight: 600;\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n}\n\n.small-input {\n  padding: 10px;\n  height: 40px;\n  border: 1px solid #ddd;\n  border-radius: 10px;\n  font-size: 16px;\n  font-family: 'Rubik', sans-serif;\n  width: 100%;\n  box-sizing: border-box;\n  background-color: #f9f9f9;\n  transition: all 0.3s ease;\n}\n\n.file-input {\n  width: 100%;\n  padding: 10px;\n  border: 1px dashed #ddd;\n  border-radius: 10px;\n  background-color: #f9f9f9;\n}\n\n.image-preview-container {\n  margin-top: 15px;\n  text-align: center;\n}\n\n.image-preview {\n  max-width: 100%;\n  max-height: 250px;\n  border-radius: 10px;\n  border: 1px solid #ddd;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  display: block;     \n  margin: 0 auto;       \n}\n\n.button-group {\n  display: flex;\n  justify-content: center;\n  gap: 20px;\n  margin-top: 30px;\n  width: 100%;\n  flex-direction: column;\n  align-items: center;\n}\n\n.admin-create-recipe button {\n  background: #004D40;\n  color: #fff;\n  border: none;\n  padding: 15px;\n  border-radius: 15px;\n  font-size: 18px;\n  font-family: 'Rubik', sans-serif;\n  cursor: pointer;\n  font-weight: 600;\n  flex: 1;\n  max-width: 250px;\n  min-width: 200px;\n  transition: all 0.3s ease;\n  margin-bottom: 20px;\n}\n\n.admin-create-recipe button:hover {\n  background: #2E7D32;\n}\n\n.cancel-btn9 {\n  background: #dc3545 !important;\n  max-width: 250px;\n}\n\n.cancel-btn9:hover {\n  background: #c82333 !important;\n}\n\n@media (max-width: 768px) {\n  .admin-create-recipe button,\n  .cancel-btn {\n    width: 80%;\n  }\n}\n\n.success-message-container {\n  position: fixed;\n  top: 70px; \n  left: 0;\n  right: 0;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  pointer-events: none; \n}\n\n.success-message28 {\n  color: #155724;\n  background-color: #d4edda;\n  border: 1px solid #c3e6cb;\n  padding: 12px 20px;\n  border-radius: 15px;\n  font-weight: 600;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  display: inline-flex;\n  align-items: center;\n  max-width: 60% !important;\n  text-align: center;\n  animation: fadeInOut 3s ease-in-out forwards;\n}\n\n.error-message28 {\n  color: #d32f2f;\n  background-color: #fde7e9;\n  border: 1px solid #d32f2f;\n  padding: 12px;\n  border-radius: 10px;\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px;\n  margin: 10px auto !important; \n  font-weight: 600;\n  width: 40%;\n  justify-content: center !important;\n  text-align: center;\n}\n\n.admin-create-recipe input:focus {\n  border-color: #A5D6A7;\n  outline: none;\n  background-color: #ffffff;\n  box-shadow: 0px 0px 8px rgba(76, 175, 80, 0.5);\n}\n\n@keyframes fadeInOut {\n  0% { opacity: 0; transform: translateY(-20px); }\n  10% { opacity: 1; transform: translateY(0); }\n  90% { opacity: 1; transform: translateY(0); }\n  100% { opacity: 0; transform: translateY(-20px); }\n}\n\n@media (max-width: 768px) {\n  .admin-create-recipe {\n    padding: 20px;\n    max-width: 90%;\n  }\n\n  .admin-create-recipe h1 {\n    font-size: 24px;\n  }\n\n  .button-group {\n    flex-direction: column;\n    gap: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
